export default {
	auth: {
		loginError: "Incorrect login information",
		signInToAccount: "Sign in to your account",
		email: "Email address",
		password: "Password",
		forgotYourPassword: "Forgot your password?",
		signIn: "Sign  in",
		resetYourPassword: "Reset your password",
		needToResetPassword: "Need to reset your password? Enter an email that we will send the recovery link to",
		sendRecovery: "Send recovery link"
	}
}
